import { z } from "zod";
import RefurbishmentPassport from "@/pages/RefurbishmentPassport";
import type { ModuleProps } from "../types";

export const passportSummaryConfig = z.object({});
export type PassportSummaryConfig = z.infer<typeof passportSummaryConfig>;

export function PassportSummaryModule(_props: ModuleProps<PassportSummaryConfig>) {
  return <RefurbishmentPassport />;
}
